import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IFileEntry } from 'app/shared/model/file-entry.model';
import { getEntity, updateEntity, createEntity, reset } from './file-entry.reducer';

export const FileEntryUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const fileEntryEntity = useAppSelector(state => state.fileEntry.entity);
  const loading = useAppSelector(state => state.fileEntry.loading);
  const updating = useAppSelector(state => state.fileEntry.updating);
  const updateSuccess = useAppSelector(state => state.fileEntry.updateSuccess);
  const handleClose = () => {
    props.history.push('/file-entry');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...fileEntryEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...fileEntryEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="xtdtApp.fileEntry.home.createOrEditLabel" data-cy="FileEntryCreateUpdateHeading">
            <Translate contentKey="xtdtApp.fileEntry.home.createOrEditLabel">Create or edit a FileEntry</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="file-entry-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('xtdtApp.fileEntry.ten')} id="file-entry-ten" name="ten" data-cy="ten" type="text" />
              <ValidatedField
                label={translate('xtdtApp.fileEntry.tenMoRong')}
                id="file-entry-tenMoRong"
                name="tenMoRong"
                data-cy="tenMoRong"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.fileEntry.duongDan')}
                id="file-entry-duongDan"
                name="duongDan"
                data-cy="duongDan"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.fileEntry.tenHienThi')}
                id="file-entry-tenHienThi"
                name="tenHienThi"
                data-cy="tenHienThi"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/file-entry" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FileEntryUpdate;
